import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=025b2520&"
import script from "./Dialog.vue?vue&type=script&lang=ts&"
export * from "./Dialog.vue?vue&type=script&lang=ts&"
import style0 from "./Dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentHeader: require('/home/runner/work/did-homepage/did-homepage/src/components/ContentHeader.vue').default,Button: require('/home/runner/work/did-homepage/did-homepage/src/components/Button.vue').default})
